/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../../common';
import { mediumMediaQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { BreakingNewsButtons } from './breakingNewsButtons';
import { BreakingNewsReadMore } from './breakingNewsReadMore';
import { BreakingNewsTitle } from './breakingNewsTitle';

interface BreakingNewsSectionProps {
    storyBackgroundImageUrl?: string;
    isVisible: boolean;
    storyUrl: string;
    enableSourceParameterOnStoriesLinks: boolean;
}

const mapStoreStateToProps = (storeState: any) => {
    const { breakingNews } = storeState || {};
    const appState = storeState.appState.appState || {};
    const { enableSourceParameterOnStoriesLinks } = appState;
    const { ThumbnailImageLink, NodeAlias } = breakingNews?.breakingNewsStory || {};

    return {
        storyBackgroundImageUrl: ThumbnailImageLink,
        storyUrl: NodeAlias,
        isVisible: breakingNews?.isVisible,
        enableSourceParameterOnStoriesLinks
    };
};

const mapDispatchToProps = {};

const source = 'weather-forecast/now';

export const BreakingNewsSection = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({
    isVisible,
    storyUrl,
    storyBackgroundImageUrl,
    enableSourceParameterOnStoriesLinks
}: BreakingNewsSectionProps) => {
    if (!isVisible || !storyUrl) {
        return null;
    } 

    if (enableSourceParameterOnStoriesLinks) {
        storyUrl = `/news/${storyUrl}?source=${source}`;
    }
    
    return (
        <Wrap>
            {enableSourceParameterOnStoriesLinks 
                ? <Container href={storyUrl} target='_self'>
                    <BackgroundContainer backgroundImageUrl={storyBackgroundImageUrl}>
                        <ContentBaseContainer>
                            <BreakingNews>
                                <ContentDetailsContainer>
                                    <BreakingNewsTitle />
                                    <BreakingNewsReadMore />
                                </ContentDetailsContainer>
                            </BreakingNews>
                        </ContentBaseContainer>
                        <ShadeContainer />
                    </BackgroundContainer>
                </Container>
                : <Container href={`/news/${storyUrl}`}>
                    <BackgroundContainer backgroundImageUrl={storyBackgroundImageUrl}>
                        <ContentBaseContainer>
                            <BreakingNews>
                                <ContentDetailsContainer>
                                    <BreakingNewsTitle />
                                    <BreakingNewsReadMore />
                                </ContentDetailsContainer>
                            </BreakingNews>
                        </ContentBaseContainer>
                        <ShadeContainer />
                    </BackgroundContainer>
                </Container>
            }
            <BreakingNewsButtons />
        </Wrap>
    );
}));

const Wrap = styled.div`
    display: flex;
    width: 100%;
    height: auto;
    padding-top: 15px;
    padding-bottom: 15px;
`;

const Container = styled.a`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: auto;
    text-decoration: none;
    position: relative;
    cursor: pointer;
`;

interface BackgroundContainerProps {
    backgroundImageUrl?: string;
}
const BackgroundContainer = styled.div<BackgroundContainerProps>`
    background-image: ${({ backgroundImageUrl }) => backgroundImageUrl && `url(${backgroundImageUrl})`};
    background-size: cover;
    position: relative;
    height: auto;
    margin-top: -21px;
    width: 100%;
    @media ${smallMediaQuery} {
        margin-top: 0;
    }
`;

const ShadeContainer = styled.div`
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.4;
    margin: 0 auto;
    margin-top: 0;
    margin-bottom: 21px;
    top: 0;
    position: absolute;
`;

const ContentBaseContainer = styled.div`
    width: 100%;
    height: auto;
    margin: 0 auto;
    margin-top: 0;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 2;
    @media ${mediumMediaQuery} {
        min-height: 293px;
        margin-bottom: 23px;
    }
    @media ${smallMediaQuery} {
        margin-top: 0;
        min-height: 130px;
    }
`;

const BreakingNews = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
    width: 100%;
    max-width: calc(1218px + 8%);
    padding: 0 4%;
    height: auto;
    margin: 0 auto;
`;

const ContentDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 50px 0 23px;
    @media ${smallMediaQuery} {
        padding: 15px 0 9px;
        min-height: 130px;
    }
    @media ${mediumMediaQuery} {
        padding: 37px 0 0;
        min-height: 293px;
    }
`;